import { Country } from '@prisma/client';


export enum NexusStatus {
  NexusTriggered = 'NexusTriggered',
  ApproachingNexus = 'ApproachingNexus',
  NoNexus = 'NoNexus',
  Remittance = 'Remittance',
}

export enum NexusEvaluationPeriod {
  PREVIOUS_OR_CURRENT_CALENDAR_YEAR = 'PREVIOUS_OR_CURRENT_CALENDAR_YEAR',
  PREVIOUS_CALENDAR_YEAR = 'PREVIOUS_CALENDAR_YEAR',
  PRECEDING_12_MONTHS = 'PRECEDING_12_MONTHS',
  PRECEDING_FISCAL_YEAR = 'PRECEDING_FISCAL_YEAR',
  PRECEDING_12_MONTHS_ENDING_SEPT_30 = 'PRECEDING_12_MONTHS_ENDING_SEPT_30',
}

export interface TaxLiability {
  estimated_tax_local_currency: number;
  currency: string;
  transaction_count: number;
  total_sales_post_breach: number;
}

export type ICommendaNexus = {
  state: string;
  country: Country;
  status: NexusStatus;
  evaluationPeriod: NexusEvaluationPeriod;
  nexusBreached: boolean;
  dateOfBreach: string;
  sales: {
    threshold: number | null;
    current: number;
    percentage: number;
    showPercentage: boolean;
  };
  transactions: {
    threshold: number | null;
    current: number;
    percentage: number;
    showPercentage: boolean;
  };
  taxLiability?: TaxLiability;
  jurisdiction?: string | null;
};

export interface RecalculateTransactionsTaxEstimatesResponse {
  data: {
    job_id: string;
    job_type: string;
    status: string;
    progress: number;
    total_invoices: number;
    processing_mode: string;
    estimated_time_ms: number;
  };
  message: string;
}